import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=d7cb01c8&scoped=true&"
import script from "./RefundPolicy.vue?vue&type=script&lang=js&"
export * from "./RefundPolicy.vue?vue&type=script&lang=js&"
import style0 from "./RefundPolicy.vue?vue&type=style&index=0&id=d7cb01c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cb01c8",
  null
  
)

export default component.exports